import {
    createContext, ReactNode, useContext,
    useMemo
} from 'react';
import { LiquidEngine } from '../../utils/liquidEngine';
import {
    chatInitialState, ChatState, createChatProvider
} from './chatProvider';
import {
    createDashboardProvider,
    dashboardInitialState, DashboardState
} from './dashboardProvider';
import {
    createModalProvider,
    modalInitialModalState,
    ModalState,
} from './modalProvider';
import {
    createPulseProvider,
    pulseInitialState, PulseState
} from './pulseProvider';

// 定义 AdminContext 的数据结构
export interface AdminState {
    chat: ChatState;
    // space: SpaceState;
    pulse: PulseState;
    dashboard: DashboardState;
    modal: ModalState;
    liquidEngine: LiquidEngine;
}

const adminInitialState: AdminState = {
    chat: chatInitialState,
    // space: spaceInitialState,
    pulse: pulseInitialState,
    dashboard: dashboardInitialState,
    modal: modalInitialModalState,
    liquidEngine: new LiquidEngine()
};

const AdminContext = createContext<AdminState>(adminInitialState);

// 完整的 AdminProvider 包装器
export const AdminProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    // 创建各个模块的 Provider
    const chat = createChatProvider();
    // const space = createSpaceProvider();
    const pulse = createPulseProvider();
    const dashboard = createDashboardProvider();
    const modal = createModalProvider();

    // 使用 useMemo 缓存 context 值
    const contextValue = useMemo(() => ({
        chat,
        // space,
        pulse,
        dashboard,
        modal,
        liquidEngine: adminInitialState.liquidEngine
    }), [chat, pulse, dashboard, modal]);

    return (
        <AdminContext.Provider value={contextValue}>
            {children}
        </AdminContext.Provider>
    );
};

// 自定义 hook，方便使用
export const useAdminContext = () => useContext(AdminContext);